import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import DataCenterTable from '../../../components/learning-development/DataCenterTable'
import { dataCenterCreateAction, dataCenterListAction } from './actions/DataCenterActions';
import { useDispatch, useSelector } from 'react-redux';
import ViewFileHistory from './ViewFileHistory';
import ViewVersionModal from './ViewVersionModal';
import { fileRestoreAPI } from 'src/api/DataCenterApi';
import { toast } from 'react-toastify';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
const DataCenter = () => {
  const [dataCenterName, setDataCenterName] = useState('');
  const [selectedDataCenter, setSelectedDataCenter] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list = [], listReqStatus, createReqStatus, currentRecord, totalRows } = useSelector((state) => state.dataCenter?.dataCenter);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [searchValue, setSearchValue] = useState('')
  const [filteredList, setFilteredList] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({
    serial: true,
    name: true,
    lastModified: true,
    modifiedBy: true,
    history: true,
    action: true
  });
  const [loading, setLoading] = useState(false)
  const toggleColumnVisibility = (column) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [column]: !prev[column]
    }));
  };

  const handleActionClick = (version, action) => {
    setSelectedVersion(version);
    setModalType(action);
  };

  const handleInputChange = (event) => {
    setDataCenterName(event.target.value);
  };

  const handleFetchDataCenters = () => {
    dispatch(dataCenterListAction());
  };

  useEffect(() => {
    handleFetchDataCenters()
  }, [])

  const handleRestore = async (version) => {
    try {
      setLoading(true)
      const res = await fileRestoreAPI({ fileHistoryId: version?._id });
      setLoading(false)
      toast.success('File restore successfully')
    } catch (error) {
      console.error('Error restoring version:', error);
    }
  };

  useEffect(() => {
    console.log('selected', modalType)
    if (modalType === 'restore') {
      if (selectedVersion !== null) {
        console.log('asdadds')
        handleRestore(selectedVersion)
      }
    }
  }, [modalType])

  const handleDataCenterSave = () => {
    if (dataCenterName || dataCenterName !== '') {
      dispatch(dataCenterCreateAction({ name: dataCenterName }));
      setDataCenterName('');
    }
  };


  const [viewManageColumn, setViewManageColumn] = useState(false)
  const offcanvasRef = useRef(null);

  const closeManageColumn = () => {
    setViewManageColumn(false)
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (offcanvasRef.current && !offcanvasRef.current.contains(event.target)) {
        closeManageColumn();
      }
    }

    if (viewManageColumn) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [viewManageColumn, closeManageColumn]);

  const handleManageColumn = () => {
    setViewManageColumn(true)
  }

  const handleSaveView = () => {
    // if (!columns?.length) return;
    // const updatedColumns = columns.map(col => ({
    //   ...col,
    //   visible: columnVisibility[col.id] ?? true
    // }));
    // dispatch(updateColumnVisibilityRequest(updatedColumns));
    setViewManageColumn(false)
  };

  const handleBack = () => {
    navigate(-1);
  };

  const filterList = () => {
    return list.filter(item =>
      item.name.toLowerCase().includes(searchValue.toLowerCase())
    );
  };

  useEffect(() => {
    setFilteredList(filterList());
  }, [list, searchValue]);




  // Column items  
  const [columnItems, setColumnItems] = useState([
    { id: 'name', label: 'Data Center Name' },
    { id: 'lastModified', label: 'Last Modified' },
    { id: 'modifiedBy', label: 'Modified by' },
    { id: 'history', label: 'History' },
    { id: 'action', label: 'Action' }
  ]);

// Drag end handler
const handleDragEnd = (result) => {
  if (!result.destination) return; //  
  
  const newItems = [...columnItems];
  const [movedItem] = newItems.splice(result.source.index, 1); // 
  newItems.splice(result.destination.index, 0, movedItem); //  
  
  setColumnItems(newItems); // 
};

  return (
    <div>
      <div className="row">
        <div className="col-xxl-12 col-xl-12">
          <div className="card h-100">
            <div className="card-body p-24">
              <h2 className="fw-semibold mb-16 d-flex align-items-center gap-4 font-24">
                <button
                  onClick={handleBack}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width={30}
                    height={30}
                  >
                    <g data-name="20-Arrow Left">
                      <path
                        fill="#0073ea"
                        d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"
                      />
                      <path
                        fill="#0073ea"
                        d="m8.41 15 5.29-5.29-1.41-1.42-7 7a1 1 0 0 0 0 1.41l7 7 1.41-1.41L8.41 17H27v-2z"
                      />
                    </g>
                  </svg>
                </button>{" "}
                Data Center
              </h2>
              <ul className="d-flex align-items-center gap-2">
                <li className="fw-medium">
                  <a
                    href="index-2.html"
                    className="d-flex align-items-center gap-1 hover-text-primary"
                  >
                    <iconify-icon
                      icon="solar:home-smile-angle-outline"
                      className="icon text-lg"
                    ></iconify-icon>
                    Special Access
                  </a>
                </li>
                <li>-</li>
                <li className="fw-medium">Data Center </li>
              </ul>
              <div className="d-flex gap-2 align-items-center py-16">
                {/* start create data center  */}
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  data-bs-toggle="modal"
                  data-bs-target="#createDataCenter"
                >
                  <svg
                    width={14}
                    height={14}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.08301 7.91665H1.49967C1.23995 7.91665 1.02224 7.8288 0.846549 7.6531C0.670855 7.47741 0.583008 7.2597 0.583008 6.99998C0.583008 6.74026 0.670855 6.52255 0.846549 6.34685C1.02224 6.17116 1.23995 6.08331 1.49967 6.08331H6.08301V1.49998C6.08301 1.24026 6.17085 1.02255 6.34655 0.846855C6.52224 0.67116 6.73995 0.583313 6.99967 0.583313C7.2594 0.583313 7.4771 0.67116 7.6528 0.846855C7.82849 1.02255 7.91634 1.24026 7.91634 1.49998V6.08331H12.4997C12.7594 6.08331 12.9771 6.17116 13.1528 6.34685C13.3285 6.52255 13.4163 6.74026 13.4163 6.99998C13.4163 7.2597 13.3285 7.47741 13.1528 7.6531C12.9771 7.8288 12.7594 7.91665 12.4997 7.91665H7.91634V12.5C7.91634 12.7597 7.82849 12.9774 7.6528 13.1531C7.4771 13.3288 7.2594 13.4166 6.99967 13.4166C6.73995 13.4166 6.52224 13.3288 6.34655 13.1531C6.17085 12.9774 6.08301 12.7597 6.08301 12.5V7.91665Z"
                      fill="white"
                    />
                  </svg>
                  Create Data Center
                </button>
                {/* End create data center  */}
                {/* Search start */}
                <div className="search w-25">
                  <span className="searchBtn position-absolute end-0 top-50 translate-middle-y me-12 line-height-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeMiterlimit={10}
                        strokeWidth={32}
                        d="M221.09 64a157.09 157.09 0 1 0 157.09 157.09A157.1 157.1 0 0 0 221.09 64Z"
                      ></path>
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeMiterlimit={10}
                        strokeWidth={32}
                        d="M338.29 338.29L448 448"
                      ></path>
                    </svg>
                  </span>
                  <input
                    type="text"
                    className="form-control radius-8"
                    id="search"
                    placeholder="Search"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </div>
                {/* Search End */}
                {/* Manage Column btn start */}
                <div className="FilterBtn">
                  <button
                    type="button"
                    // data-bs-toggle="offcanvas"
                    // data-bs-target="#manageColRightPopup"
                    // aria-controls="manageColRightPopup"
                    className="btn btn-outline-primary-600 grbtn heightAllBtnSet44 text-sm radius-8 px-20 py-9 d-flex align-items-center gap-2"
                    onClick={handleManageColumn}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={20}
                      height={20}
                      fill="currentColor"
                      className="bi bi-columns"
                      viewBox="0 0 16 16"
                    >
                      <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm8.5 0v8H15V2zm0 9v3H15v-3zm-1-9H1v3h6.5zM1 14h6.5V6H1z"></path>
                    </svg>{" "}
                    Manage Column
                  </button>
                </div>
                {/* Manage Column btn end */}
              </div>
              {/* start table sec  */}
              <DataCenterTable
                columnVisibility={columnVisibility}
                selectedDataCenter={selectedDataCenter} setSelectedDataCenter={setSelectedDataCenter} tableData={filteredList} totalRows={totalRows} />
              {/* End table sec  */}
            </div>
          </div>
        </div>
      </div>


      <>
        {/* start Create Data Center Popup  */}
        <div
          className="modal fade exportPopSec"
          id="createDataCenter"
          tabIndex={-1}
          aria-labelledby="createDataCenterLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="createDataCenterLabel">
                  Create Data Center
                </h1>
                <span data-bs-dismiss="modal" aria-label="Close">
                  <svg
                    width={16}
                    height={15}
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8 6.3216L14.0778 0.243764C14.4029 -0.0812545 14.9312 -0.0812545 15.2562 0.243764C15.5813 0.568782 15.5813 1.09714 15.2562 1.42216L9.1784 7.5L15.2562 13.5778C15.5813 13.9029 15.5813 14.4312 15.2562 14.7562C14.9312 15.0813 14.4029 15.0813 14.0778 14.7562L8 8.6784L1.92216 14.7562C1.59714 15.0813 1.06878 15.0813 0.743764 14.7562C0.418745 14.4312 0.418745 13.9029 0.743764 13.5778L6.8216 7.5L0.743764 1.42216C0.418745 1.09714 0.418745 0.568782 0.743764 0.243764C1.06878 -0.0812545 1.59714 -0.0812545 1.92216 0.243764L8 6.3216Z"
                      fill="#323338"
                    />
                  </svg>
                </span>
              </div>
              <div className="modal-body">
                <div className="sheetPopuDivider" />
                <div className="contentAddColsSec d-block exportIput">
                  <label
                    htmlFor=""
                    className="toggleText form-label mb-0"
                    style={{ fontSize: 16 }}
                  >
                    Data Center Name
                  </label>
                  <input
                    type="text"
                    id="text"
                    className="form-control"
                    placeholder="Enter a Data Center Name "
                    value={dataCenterName}
                    onChange={handleInputChange}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  data-bs-dismiss="modal"
                  onClick={handleDataCenterSave}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* End Create Data Center Popup  */}
        {/* === Start Manage Column ==== */}
        {viewManageColumn && (
          <div
            className="offcanvas offcanvas-end filterSecPopup mangeColsLeadev show"
            id="manageColRightPopup"
            aria-labelledby="manageColRightLayout"
            ref={offcanvasRef}
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="manageColRightLayout">
                Manage Column
              </h5>
              <button
                type="button"
                className="btn-close d-none"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body pt-0 learnigPopuMange">
              <div className="assignPopoHeight">
                <div className="mangeSearchSec magecolslearning">
                  <svg
                    width={17}
                    height={16}
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3215 14.9883L12.0198 10.6866C12.9629 9.55576 13.5321 8.10274 13.5321 6.51846C13.5321 2.92412 10.608 0 7.01362 0C3.41926 0 0.495117 2.92412 0.495117 6.51846C0.495117 10.1128 3.41926 13.0369 7.01362 13.0369C8.59791 13.0369 10.0509 12.4677 11.1818 11.5246L15.4835 15.8264C15.5992 15.9421 15.7509 16 15.9025 16C16.054 16 16.2057 15.9421 16.3215 15.8264C16.553 15.5948 16.553 15.2197 16.3215 14.9883ZM1.6803 6.51846C1.6803 3.57774 4.07259 1.18517 7.01362 1.18517C9.95465 1.18517 12.3469 3.57774 12.3469 6.51846C12.3469 9.45917 9.95465 11.8517 7.01362 11.8517C4.07259 11.8517 1.6803 9.45917 1.6803 6.51846Z"
                      fill="#323338"
                    />
                  </svg>
                  <input
                    type="text"
                    className="managecolsSearch"
                    placeholder="Find columns to show/hide"
                  />
                </div>
                {/* <div id="manageColMenu" className="selectSec py-0">
                  <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="selectAllmenu"
                      checked={Object.values(columnVisibility).every(Boolean)}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        const updatedVisibility = Object.fromEntries(
                          Object.keys(columnVisibility).map((key) => [key, newValue])
                        );
                        setColumnVisibility(updatedVisibility);
                      }}
                    />
                    <label htmlFor="selectAllmenu">
                      All columns
                    </label>
                  </div>
                  <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                    <div className="d-flex gap-12">
                      <div className="">
                        <svg
                          width={16}
                          height={26}
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                        </svg>
                      </div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="mangCol1"
                        checked={columnVisibility.name}
                        onChange={() => toggleColumnVisibility('name')}
                      />
                      <label htmlFor="mangCol1">Data Center Name</label>
                    </div>
                  </div>
                  <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                    <div className="d-flex gap-12">
                      <div className="">
                        <svg
                          width={16}
                          height={26}
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                        </svg>
                      </div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="mangCol2"
                        checked={columnVisibility.lastModified}
                        onChange={() => toggleColumnVisibility('lastModified')}
                      />
                      <label htmlFor="mangCol2">Last Modified</label>
                    </div>
                  </div>
                  <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                    <div className="d-flex gap-12">
                      <div className="">
                        <svg
                          width={16}
                          height={26}
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                        </svg>
                      </div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="mangCol3"
                        checked={columnVisibility.modifiedBy}
                        onChange={() => toggleColumnVisibility('modifiedBy')}
                      />
                      <label htmlFor="mangCol3">Modified by</label>
                    </div>
                  </div>
                  <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                    <div className="d-flex gap-12">
                      <div className="">
                        <svg
                          width={16}
                          height={26}
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                        </svg>
                      </div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="mangCol4"
                        checked={columnVisibility.history}
                        onChange={() => toggleColumnVisibility('history')}
                      />
                      <label htmlFor="mangCol4">History</label>
                    </div>
                  </div>
                  <div className="form-group AllFilter_Select py-0 mangeColHoversec">
                    <div className="d-flex gap-12">
                      <div className="">
                        <svg
                          width={16}
                          height={26}
                          viewBox="0 0 16 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                          <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                          <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                        </svg>
                      </div>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="mangCol5"
                        checked={columnVisibility.action}
                        onChange={() => toggleColumnVisibility('action')}
                      />
                      <label htmlFor="mangCol5">Action</label>
                    </div>
                  </div>
                </div> */}
                <div id="manageColMenu" className="selectSec py-0">
                <DragDropContext onDragEnd={handleDragEnd}>
  <Droppable droppableId="columns">
    {(provided) => (
      <div {...provided.droppableProps} ref={provided.innerRef}>
        {/* "All Columns" Checkbox (Non-Draggable) */}
        <div className="form-group AllFilter_Select py-0 mangeColHoversec">
          <input
            className="form-check-input"
            type="checkbox"
            id="selectAllmenu"
            checked={Object.values(columnVisibility).every(Boolean)}
            onChange={(e) => {
              const newValue = e.target.checked;
              const updatedVisibility = Object.fromEntries(
                Object.keys(columnVisibility).map((key) => [key, newValue])
              );
              setColumnVisibility(updatedVisibility);
            }}
          />
          <label htmlFor="selectAllmenu">All columns</label>
        </div>

        {/* Draggable Items */}
        {columnItems.map((item, index) => (
          <Draggable key={item.id} draggableId={item.id} index={index}>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className="form-group AllFilter_Select py-0 mangeColHoversec"
              >
                <div className="d-flex gap-12">
                  <div className="drag-handle" style={{ cursor: 'grab' }}>
                    <svg
                      width={16}
                      height={26}
                      viewBox="0 0 16 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="4.5" cy="2.5" r={2} fill="#94A3B8" />
                      <circle cx="11.5" cy="2.5" r={2} fill="#94A3B8" />
                      <circle cx="4.5" cy="9.5" r={2} fill="#94A3B8" />
                      <circle cx="11.5" cy="9.5" r={2} fill="#94A3B8" />
                      <circle cx="4.5" cy="16.5" r={2} fill="#94A3B8" />
                      <circle cx="11.5" cy="16.5" r={2} fill="#94A3B8" />
                      <circle cx="4.5" cy="23.5" r={2} fill="#94A3B8" />
                      <circle cx="11.5" cy="23.5" r={2} fill="#94A3B8" />
                    </svg>
                  </div>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`mangCol-${item.id}`}
                    checked={columnVisibility[item.id]}
                    onChange={() => toggleColumnVisibility(item.id)}
                  />
                  <label htmlFor={`mangCol-${item.id}`}>{item.label}</label>
                </div>
              </div>
            )}
          </Draggable>
        ))}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
</DragDropContext>
</div>
              </div>
              <div className="">
                <button
                  type="button"
                  className="btn btn-primary radius-6 px-14 py-6 text-sm w-100 my-12"
                  onClick={handleSaveView}
                >
                  Save as new view
                </button>
              </div>
            </div>
          </div>
        )}
        {/* === End Manage Column ==== */}
        {/* start Delete cols Popup  */}
        <div
          className="modal fade deleteColsSec"
          id="deletHistory"
          tabIndex={-1}
          aria-labelledby="deletHistoryLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="deletHistoryLabel">
                  Delete History?
                </h1>
                <span data-bs-dismiss="modal" aria-label="Close">
                  <svg
                    width={16}
                    height={15}
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8 6.3216L14.0778 0.243764C14.4029 -0.0812545 14.9312 -0.0812545 15.2562 0.243764C15.5813 0.568782 15.5813 1.09714 15.2562 1.42216L9.1784 7.5L15.2562 13.5778C15.5813 13.9029 15.5813 14.4312 15.2562 14.7562C14.9312 15.0813 14.4029 15.0813 14.0778 14.7562L8 8.6784L1.92216 14.7562C1.59714 15.0813 1.06878 15.0813 0.743764 14.7562C0.418745 14.4312 0.418745 13.9029 0.743764 13.5778L6.8216 7.5L0.743764 1.42216C0.418745 1.09714 0.418745 0.568782 0.743764 0.243764C1.06878 -0.0812545 1.59714 -0.0812545 1.92216 0.243764L8 6.3216Z"
                      fill="#323338"
                    />
                  </svg>
                </span>
              </div>
              <div className="modal-body">
                <div className="sheetPopuDivider" />
                <div className="contentAddColsSec d-block deletTextBody">
                  <h6>Are you sure you want to delete your browsing history? </h6>
                  <h6 className="fw-normal">This action cannot be undone.</h6>
                </div>
                <div className="d-flex deletButton">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary activeRed">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* start Delete cols Popup  */}
        {/* === Start View History ==== */}
        <ViewFileHistory dataCenterId={selectedDataCenter} handleActionClick={handleActionClick} />
        {/* === End View History ==== */}
        {/* start Version History Popup  */}

        <ViewVersionModal
          isOpen={modalType === "view"}
          version={selectedVersion}
          onClose={() => setModalType(null)}
        />
        {/* End Version History Popup  */}
      </>

    </div>
  )
}

export default DataCenter
